import { useId } from 'react';

interface BrandIconProps {
  size?: number;
  className?: string;
}

export function BrandIcon({ size = 38, className = '' }: BrandIconProps) {
  const id = useId().replace(/:/g, '');
  const gradientId = `brand-icon-bg-${id}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={`shrink-0 ${className}`}
      aria-hidden
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#1E8F7C" />
          <stop offset="100%" stopColor="#123832" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="9" fill={`url(#${gradientId})`} />
      <g
        transform="translate(4, 4)"
        fill="none"
        stroke="#EAFBF7"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect width="18" height="18" x="3" y="4" rx="2" />
        <path d="M16 2v4" />
        <path d="M8 2v4" />
        <path d="M3 10h18" />
        <path d="M9.5 15.25L11.75 17.5L15.5 13.5" stroke="#2FD3B8" strokeWidth="2.25" />
      </g>
    </svg>
  );
}
